import { cn } from '@commenda/utils';
import { StepperItem } from './StepperItem';

interface StepperItemProps {
  id: string;
  label: string;
  description?: string;
  isActive: boolean;
  isCompleted: boolean;
  onClick: () => void;
  disabled?: boolean;
}

interface StepperProps {
  children?: React.ReactNode;
  items: StepperItemProps[];
  className?: string;
}

export const Stepper = ({ children, items, className }: StepperProps) => {
  return (
    <div
      className={cn(
        'bg-bg-secondary p-xl border-r h-full w-full max-w-[342px] flex flex-col justify-between',
        className ?? ''
      )}
    >
      <div className="flex flex-col gap-xxs">
        {items.map((item) => (
          <StepperItem key={item.id} {...item} />
        ))}
      </div>
      {children}
    </div>
  );
};
